import { ShieldCheck, Leaf, FileCheck2, Umbrella } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const points = [
  {
    icon: ShieldCheck,
    title: "100% पुलिस Verified स्टाफ",
    en: "Police Verified Staff",
    desc: "हर सफाई कर्मचारी की पुलिस वेरिफिकेशन — आपकी संपत्ति की पूरी सुरक्षा।",
  },
  {
    icon: Leaf,
    title: "Taski / Diversey केमिकल",
    en: "Eco-Friendly Chemicals",
    desc: "सिर्फ ब्रांडेड, इको-फ्रेंडली केमिकल — सेहत और पर्यावरण दोनों सुरक्षित।",
  },
  {
    icon: FileCheck2,
    title: "SLA आधारित गुणवत्ता",
    en: "Service Level Agreement",
    desc: "लिखित SLA के साथ गुणवत्ता की गारंटी — वादा सिर्फ़ ज़ुबानी नहीं, कागज़ पर।",
  },
  {
    icon: Umbrella,
    title: "पूर्ण Public Liability बीमा",
    en: "Full Insurance Cover",
    desc: "काम के दौरान किसी भी नुकसान की पूर्ण बीमा कवरेज — बेफिक्र रहिए।",
  },
];

export const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="py-24 md:py-32 border-t border-white/10 bg-[#14242F]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal>
        <SectionLabel>[ 03 — हमें क्यों चुनें / WHY US ]</SectionLabel>
        <h2 className="mt-4 font-khand font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-3xl">
          भरोसा, <span className="text-[#00F0FF]">लिखित में</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div data-testid="govt-project-image" className="relative mt-12 border border-white/10 overflow-hidden group">
          <img
            src="/images/govt-project.jpg"
            alt="सरकारी व नगर पालिका परियोजना कार्य"
            className="w-full aspect-[21/9] object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0C1B24] via-transparent to-transparent" />
          <p className="absolute bottom-4 left-6 font-khand font-semibold text-2xl md:text-3xl">
            सरकारी व नगर पालिका परियोजनाओं का अनुभव
          </p>
        </div>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border border-white/10 divide-y sm:divide-y-0 lg:divide-x divide-white/10">
        {points.map((p, i) => (
          <Reveal
            key={p.en}
            delay={i * 0.1}
            className={`group p-8 md:p-10 hover:bg-[#1E3440] transition-colors ${i % 2 === 1 ? "sm:border-l" : ""} ${i >= 2 ? "sm:border-t lg:border-t-0" : ""} border-white/10`}
          >
            <p.icon
              data-testid={`why-icon-${i}`}
              className="w-8 h-8 text-[#00F0FF] transition-transform duration-500 group-hover:-translate-y-1"
            />
            <h3 className="mt-6 font-khand font-semibold text-2xl leading-snug">{p.title}</h3>
            <p className="mt-1 font-spacemono text-[10px] tracking-[0.25em] text-slate-500 uppercase">
              {p.en}
            </p>
            <p className="mt-4 text-sm text-slate-400 font-mukta leading-relaxed">{p.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
